import React from 'react';
import PropTypes from 'prop-types';

import Picture from '../../Util/Picture/Picture';
import Slider from '../../Util/Slider/SliderView';

// import assets
import './imageSliderModule.scss';


const sliderSettings = {
  accessibility: true,
  variableWidth: true,
  centerMode: false,
  infinite: true,
  vertical: false,
  initialSlide: 0,
  centerPadding: '0px',
  arrows: true,
  adaptiveHeight: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  pauseOnHover: true,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 99999,
      settings: {
        slidesToShow: 3,
      },
    },
  ],
};
const ImageSliderModuleView = props => (
  <div className="m-article-module m-article-module--wide">
    <div className={'m-image-slider-module'}>
      <Slider sliderSettings={sliderSettings}>
        {props.images.map((image, index) => (
          <div key={`${props.id}_ ${image.src.default}`} className={'m-image-slider-module__image slick-slide'}>
            <Picture
              class={'m-image-slider-module__pic'}
              src={{
                sm: image.src['515'],
                md: image.src['445'],
                lg: image.src['620'],
                xl: image.src['620'],
                xxl: image.src['1020'],
                xxxl: image.src['1600'],
                default: image.src.default,
              }}
              alt={image.alt}
              imageCollection={props.images}
              collectionIndex={index}
            />
            <div className={'m-image-slider-module__img-desc'} dangerouslySetInnerHTML={{ __html: image.desc }} />
          </div>
        ))}
      </Slider>
    </div>
  </div>
);

ImageSliderModuleView.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.shape({
      sm: PropTypes.string,
      md: PropTypes.string,
      lg: PropTypes.string,
      xl: PropTypes.string,
      xxl: PropTypes.string,
      default: PropTypes.string,
    }),
    alt: PropTypes.string,
    desc: PropTypes.string,
  })),
  id: PropTypes.string,
};

ImageSliderModuleView.defaultProps = {
  images: [],
  id: '',
};

export default ImageSliderModuleView;



// WEBPACK FOOTER //
// ./frontend/js/Components/Modules/ImageSliderModule/ImageSliderModuleView.jsx